
import { Options, Vue } from 'vue-class-component'
import Farm from '@/farm/Farm'
import EmployeeCard from '@/components/EmployeeCard.vue'
import ValueMeter from '@/components/ui/ValueMeter.vue'
import EmployeeCardSmall from '@/components/EmployeeCardSmall.vue'
import Research from '@/Research'
import Employee from '@/employee/Employee'
import FarmStatusCard from '@/components/FarmStatusCard.vue'
import StatusBar from '@/components/StatusBar.vue'

@Options({
  components: {
    EmployeeCard, EmployeeCardSmall, ValueMeter, FarmStatusCard, StatusBar
  },
  props: {
    farm: Object
  },
  emits: ['close'],
  methods: {
    log(msg: any) {
      console.log(msg)
    },
    select(e: Employee) {
      this.selectedEmployeeId = e.uuid
    },
    hireNew() {
      this.farm.hire()
      if (this.farm.state.employees.length > 0) {
        this.select(this.farm.state.employees[this.farm.state.employees.length - 1])
      }
    }
  },
  computed: {
  },
  async created() {
    //let farm = new Farm()
    //await farm.load()
    //this.farm = farm
    this.isLoaded = true
  }
})
export default class PastureView extends Vue {
  isLoaded = false
  farm!: Farm
  selectedEmployeeId = ''
}
